import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Container, Typography, Link, Box, Paper } from '@mui/material';

const Sitemap = () => {
  const sitemapLinks = [
    { title: 'Main Pages', links: [
      { name: 'Home', path: '/' },
      { name: 'Search all products', path: '/s' },
      { name: 'About Us', path: '/about' },
      { name: 'Contact', path: '/contact' },
      { name: 'Pricing', path: '/pricing' },
    ]},
    { title: 'Account', links: [
      { name: 'Login', path: '/login' },
      { name: 'Sign Up', path: '/signup' },
      { name: 'Business Sign Up', path: '/signup-business' },
      { name: 'Distributor Sign Up', path: '/signup-distributor' },
    ]},
    { title: 'User Features', links: [
      { name: 'My Products', path: '/my-products' },
      { name: 'Favorite Products', path: '/favorite-products' },
      { name: 'Profile', path: '/profile' },
    ]},
    { title: 'Legal', links: [
      { name: 'Terms of Service', path: '/terms-and-services' },
      { name: 'Privacy Policy', path: '/privacy-policy' },
    ]},
  ];

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h3" component="h1" gutterBottom align="center">
        Sitemap
      </Typography>
      
      {sitemapLinks.map((section, index) => (
        <Paper key={index} sx={{ p: 3, mb: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            {section.title}
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
            {section.links.map((link, linkIndex) => (
              <Link
                key={linkIndex}
                component={RouterLink}
                to={link.path}
                sx={{ 
                  mr: 3,
                  color: 'primary.main',
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'underline'
                  }
                }}
              >
                {link.name}
              </Link>
            ))}
          </Box>
        </Paper>
      ))}
    </Container>
  );
};

export default Sitemap; 